document.addEventListener('DOMContentLoaded', function () {
    const searchIcon = document.querySelector('.icon-mobile__search .search-icon');
    const closeIcon = document.querySelector('.icon-mobile__search .close-icon');
    const searchModal = document.querySelector('.header__search');
    const floatingNav = document.getElementById('second-header-navigation');

    if (searchIcon && closeIcon && searchModal && floatingNav) {
        floatingNav.classList.add('show'); // Make floatingNav visible immediately

        const toggleSearchModal = (isOpen) => {
            searchModal.classList.toggle('active', isOpen);
            searchIcon.style.display = isOpen ? 'none' : 'flex';
            closeIcon.style.display = isOpen ? 'flex' : 'none';
        };

        searchIcon.addEventListener('click', () => toggleSearchModal(true));

        closeIcon.addEventListener('click', () => toggleSearchModal(false));

        document.addEventListener('click', (event) => {
            if (!searchModal.contains(event.target) && !searchIcon.contains(event.target)) {
                toggleSearchModal(false);
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const menuIcon = document.querySelector('.icon-mobile__menu .menu-icon');
    const closeIcon = document.querySelector('.icon-mobile__menu .close-icon');
    const headerDrawer = document.querySelector('header-drawer');
    const floatingNav = document.getElementById('second-header-navigation');
    const detailsOpen = document.getElementById('Details-menu-drawer-container');

    if (menuIcon && closeIcon && headerDrawer && floatingNav && detailsOpen) {
        floatingNav.classList.add('show'); // Make floatingNav visible immediately

        const toggleHeaderDrawer = (isOpen) => {
            headerDrawer.classList.toggle('active', isOpen);
            menuIcon.style.display = isOpen ? 'none' : 'flex';
            closeIcon.style.display = isOpen ? 'flex' : 'none';

            if (isOpen) {
                detailsOpen.setAttribute('open', 'true');
            } else {
                detailsOpen.removeAttribute('open');
            }
        };

        menuIcon.addEventListener('click', () => toggleHeaderDrawer(true));

        closeIcon.addEventListener('click', () => toggleHeaderDrawer(false));

        document.addEventListener('click', (event) => {
            if (!headerDrawer.contains(event.target) && !menuIcon.contains(event.target)) {
                toggleHeaderDrawer(false);
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const secondNav = document.getElementById('second-header-navigation');
    let lastScrollTop = 0;
    secondNav.classList.add('show'); // Make floatingNav visible immediately

    secondNav.style.transition = 'transform 0.3s ease';

    window.addEventListener('scroll', function () {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition > lastScrollTop || scrollPosition < lastScrollTop) {
            secondNav.classList.add('show');
        }

        lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
    });

    document.addEventListener('click', function () {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition === 0) {
            secondNav.classList.add('show');
        }
    });
});

  document.addEventListener('DOMContentLoaded', function() {
  const cartIcon = document.getElementById('cart-icon-bubble-second');
  const cartDrawer = document.querySelector('cart-drawer.drawer');

  cartIcon.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default link behavior
    openCartDrawer();
  });

  function openCartDrawer() {
    cartDrawer.classList.add('active'); // Add a class to show the drawer
  }
});
